import graphql from './graphql';

const query = /* GraphQL */ `
  query putSignedUrl($key: String!, $contentType: String) {
    putSignedUrl(key: $key, contentType: $contentType) {
      signedUrl
    }
  }
`;

const S3putSignedUrl = async ({ key, contentType }) =>
  graphql(query, { key, contentType }).then(({ putSignedUrl }) => putSignedUrl);

export default S3putSignedUrl;
